/**
 * Copyright 2020 New Light Technologies, Inc.
 *
 * With Supporting Sponsorship from the Federal Emergency Management Agency (Contract: GSA Stars II GS-06F-0968Z)
 * In accordance with FAR 52.227-14(c)(iii), New Light Technologies, Inc. grants to the Government and others acting on its behalf a paid-up, nonexclusive, irrevocable, worldwide license in such copyrighted computer software and data to reproduce, prepare derivative works, and perform publicly and display publicly (but not to distribute copies to the public) by or on behalf of the Government.
 * Any other use, distribution, reproduction, modification, or publication without the prior express written authorization of New Light Technologies, Inc. is strictly prohibited.
 * All other rights are reserved by their respective copyright holders.
 *
 */

/**
 * A feature property read by a column name chosen at runtime, as a number.
 *
 * The legend's elevation and primary keys are column names picked from a list, so
 * they are not compile-time keys of any one section's properties type. A column
 * holding anything but a number contributes no elevation.
 */
export function numberProperty(properties: object | null | undefined, key: string): number {
  if (properties == null) {
    return 0;
  }
  const value: unknown = Reflect.get(properties, key);
  return typeof value === 'number' ? value : 0;
}
